import { lazyLoad } from 'components/ui/LazyLoad'

// RouteType
export const profileRoutes = {
  profile: {
    path: '/profile',
    component: lazyLoad(() => import('views/profile/Profile')),
    views: {
      buy: {
        path: '/profile/buy',
        exact: true,
        component: lazyLoad(() => import('views/profile/BuyCredits/BuyMain')),
      },
      account: {
        path: '/profile/account',
        exact: true,
        component: lazyLoad(() => import('views/profile/Account')),
      },
      downloads: {
        path: '/profile/purchased',
        exact: true,
        component: lazyLoad(() => import('views/profile/Downloads')),
      },
      favourites: {
        path: '/profile/favourites',
        exact: true,
        component: lazyLoad(() => import('views/profile/Favourites')),
      },
      invoices: {
        path: '/profile/transactions',
        exact: true,
        component: lazyLoad(() => import('views/profile/Invoices')),
      },
      transfers: {
        path: '/profile/transfers',
        exact: true,
        component: lazyLoad(() => import('views/profile/Transfers')),
      },
      following: {
        path: '/profile/following',
        exact: true,
        component: lazyLoad(() => import('views/Empty')),
      },
      collections: {
        path: '/profile/collections',
        exact: true,
        component: lazyLoad(() => import('views/Empty')),
      },
      devices: {
        path: '/profile/devices',
        exact: true,
        component: lazyLoad(() => import('views/Empty')),
      },
      subscription: {
        path: '/profile/billing',
        exact: true,
        component: lazyLoad(() => import('views/profile/Subscription')),
      },
    },
  },
} as const
